exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-2rem[data-v-2433ee22] {\n  width: 2rem;\n}", ""]);

// exports
